import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import TourList from '../../components/admin/TourList';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Tours = () => {
  return (
    <AdminLayout>
      <div className="p-8">
        {/* Breadcrumbs */}
        <div className="flex items-center gap-2 mb-8 text-sm">
          <Link to="/kh-admin" className="text-white/70 hover:text-white transition-colors">
            <Home className="w-4 h-4" />
          </Link>
          <ChevronRight className="w-4 h-4 text-white/40" />
          <span className="text-white">Tours</span>
        </div>

        <TourList />
      </div>
    </AdminLayout>
  );
};

export default Tours;